var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"label","label":"番号","width":"60"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":_vm.columnLabel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }